import { IconButton, Typography } from "@mui/material";
import { useAppContext } from "src/hooks";
import { capitalize } from "lodash";
import KeyboardVoiceIcon from '@mui/icons-material/KeyboardVoice';
import ImageIcon from '@mui/icons-material/Image';
import { truncateText, formatAudioDuration } from "src/utils/audioDurationFormat";
import { _getMessageDetail } from "src/DAL/chat";
import { useSnackbar } from "notistack";
import { useEffect, useState, useRef, memo } from "react";

function TempReply({
    setRepliedMessage,
    message,
    handleReplyClick,
}) {
    const { messageList, } = useAppContext();
    const { dispatch_get_user_profile } = useAppContext();
    const { enqueueSnackbar } = useSnackbar();
    const [targetMessageId, setTargetMessageId] = useState(null);
    const messageListRef = useRef([]);

    useEffect(() => {
        messageListRef.current = messageList;
    }, [messageList]);

    return (
        <div className="reply-item" style={{
            borderLeft: (message.reply_message_detail.sender_id == dispatch_get_user_profile().user_id) ? "5px darkgreen solid" : ""
        }} onClick={handleReplyClick}>
            <div className="reply-flex">
                <Typography variant="h6" fontSize="11px" fontWeight="600"
                    style={{
                        color: (message.reply_message_detail.sender_id == dispatch_get_user_profile().user_id) ? "darkgreen" : ""
                    }}
                    className="user-profile">
                    {
                        (message.reply_message_detail.sender_id == dispatch_get_user_profile().user_id) ?
                            "You" : capitalize(message.reply_message_detail?.message_sender?.first_name)
                    }

                </Typography>
                <Typography variant="caption2" className="reply-style">
                    {
                        (message.reply_message_detail.image && !message.reply_message_detail.audio_duration) &&
                        <>
                            <ImageIcon className="chat-user-icons chat-icon-reply" />
                            Image
                        </>
                    }
                    {
                        (message.reply_message_detail.image && message.reply_message_detail.audio_duration) &&
                        <>
                            <KeyboardVoiceIcon className="chat-user-icons" />
                            {formatAudioDuration(message.reply_message_detail?.audio_duration)}
                        </>
                    }
                    {
                        (message.reply_message_detail.image == "") &&
                        truncateText(message.reply_message_detail?.text, 22)
                    }
                </Typography>
            </div>
        </div>
    )
}
export default memo(TempReply);